export const API_URL = process.env.REACT_APP_API_URL || 'api';

export const WEB_URL = process.env.REACT_APP_WEB_URL || 'web';

export const WEB_DOMAIN = process.env.REACT_APP_WEB_DOMAIN || 'verbonden.test';

export const PAGE_URL = `${API_URL}/v1/page-management/pages`;
export const POST_URL = `${API_URL}/v1/post-management/posts`;
